import styled from 'styled-components';
import { fontVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';

export const CategoryFilterTitle = styled.p`
  font-size: 20px;
  font-weight: ${fontVariables.FONT_WEIGHT_BOLD};
  text-align: center;
  margin: 34px 0;
`;
